/* Customization of the jquery-ui Autocomplete widget */

/* Default code: */
// _renderItem: function( ul, item ) {
//   return $( "<li>" )
//     .append( $( "<div>" ).text( item.label ) )
//     .appendTo( ul );
// }

$.widget( "ui.autocomplete", $.ui.autocomplete, {
  _renderItem: function( ul, item ) {
    if (item.image_url) {
      return $( "<li class='with_image d-flex'>" )
        .append( $( "<div class='flex-grow-1'>" ).text( item.label ) )
        .append( $( "<div class='flex-shrink-0 ms-3'>" ).append( $( `<img src="${item.image_url}" alt="Afbeelding ${item.label}" loading="lazy">`)))
        .appendTo( ul );
    } else {
      return $( "<li>" )
        .append( $( "<div>" ).text( item.label ) )
        .appendTo( ul );
    }
  }
});
